@if (focus) {
    <div class="complete">
        <mat-selection-list class="p-0" #selection [multiple]="false" [formControl]="select">
            @for (hire of hiringAutocompleteOptions | search: null : search?.value ?? ''; track hire) {
                <mat-list-option [value]="hire">
                    <div class="list-item">
                        {{ hire }}
                    </div>
                </mat-list-option>
            }
        </mat-selection-list>
    </div>
}
<input
    [formControl]="search"
    (focusin)="focus = true"
    (click)="focus = true"
    (keydown.arrowDown)="selection.focus()"
    matInput
    placeholder="Inhuurnaam"
    type="text" />
